import { render, staticRenderFns } from "./CalculateGramPercentages.vue?vue&type=template&id=1075e406&scoped=true&"
import script from "./CalculateGramPercentages.vue?vue&type=script&lang=js&"
export * from "./CalculateGramPercentages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1075e406",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
